import type { LoginModalEventDetail } from '../LoginModalManager';
import { LoginModalAutotestHooks } from './hooks';

export type LoginModalAutotestResolution = {
  detail: LoginModalEventDetail;
  autotest?: LoginModalAutotestHooks;
};

// No wave is live on this surface, so every visitor gets control: the
// opener's detail object passes through untouched (the codified Q2 v1
// lesson) and no hooks reach the sockets. The sockets themselves stay
// wired — slots, wrapOnSuccess, onClose, ctaDefaultExpanded — so the next
// wave lands entirely inside this directory: resolve a bucket, build hooks,
// rewrite the detail.
export function resolveLoginModalAutotest(
  detail: LoginModalEventDetail,
): LoginModalAutotestResolution {
  return { detail };
}

// Page-level socket, running wherever the manager mounts. Inert between
// waves; a wave needing page-load-time state (storage seeding, post-close
// UI rehydration) wires it here.
export function useAutotestPageInit(): void {
  // No wave is live.
}
